import { NgModule, InjectionToken } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './core/auth';

export const externalUrlProvider = new InjectionToken('externalUrlRedirectResolver');

const sharedRoutes: Routes = [
  {
    path: 'logout-complete',
    loadComponent: async () => import('./core/auth/components/logout-complete/logout-complete.component').then((c) => c.LogoutCompleteComponent),
  },
  {
    path: 'occupancy/:id',
    loadComponent: async () =>
      import('./features/occupancy/components/occupancy-screen/occupancy-screen.component').then(
        (component) => component.OccupancyScreenComponent
      ),
    title: 'routing.occupancy.title'
  },
  {
    path: '',
    loadChildren: async () => import('./main/main.module').then((m) => m.MainModule),
    canActivate: [authGuard]
  },
  { path: '**', redirectTo: 'appointment' }
];

@NgModule({
  imports: [CommonModule, RouterModule.forRoot(sharedRoutes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
